import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { jumpToUser } from 'src/helper/webviewFun'
import lang from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import ReminderBtn from 'src/component/myRuleButton'
import score from 'src/helper/score'
import http from 'src/helper/http'
@inject('store')
@observer
export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: lang.en,
    language: 'en',
    minute: 0,
    day: 0,
    hour: 0,
    second: 0,
    topReward:[],
    topHighList:[],
    myRanking:{},
    rankingList:[],
    voteReward:[],
    myInfo:{},
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    const uid = await setUidToken(this.props.location.query)
    language =await getlangV2(language, lang)
    if (language == 'ar') {
      setDocumentTitle('رمضان')
    } else if (language == 'tr') {
      setDocumentTitle('Ramazan')
    } else {
      setDocumentTitle("Ramadan")
    }
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    this.setState({
      lang: setlang(language, lang),
      language: language,
      uid,
    })
  
    this.getUserInfoWeb()
    this.getCprewardlist()
    this.getBroadcastList()
    this.getCountDownTime()
  }

   getUserInfoWeb = async (uid)=>{
    let res = await http.post('/web/MyAccountInfo', { uid: uid })
    if (res && res.code == 0 ) {
      this.setState({
        myInfo:res.res
      })
    }
  }

  countDown = (times = 2299085) => {
    let { lang } = this.state
    var timer = null
    timer = setInterval(() => {
      var day = 0,
        hour = 0,
        minute = 0,
        second = 0
      if (times > 0) {
        day = Math.floor(times / (60 * 60 * 24))
        hour = Math.floor(times / (60 * 60)) - day * 24
        minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
        second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
      }
      if (day <= 9) day = day
      if (hour <= 9) hour = '0' + hour
      if (minute <= 9) minute = '0' + minute
      if (second <= 9) second = '0' + second
      let daystr = ''
      if (day > 0) {
        // daystr = day
        daystr = day + ' ' + lang.days
      }
      this.setState({
        minute,
        day,
        hour,
        second
      })
      times--
    }, 1000)
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  getCprewardlist = async () => {
    let res = await http.post('/web/broadcast/reward')
    if (res.code == 0) {
      this.setState({
        voteReward: res.res.rankReward4,
        topReward: [res.res.rankReward1, res.res.rankReward2, res.res.rankReward3 ]
      })
    }
  }

  getCountDownTime = async () => {
    let nowTime = Math.floor(new Date().getTime() / 1000)
    let res = await http.post('/web/broadcast/timeinfo')
    if (nowTime > res.res.beginTimestamp) {
      this.countDown(res.res.leftTimestamp)
    }
  }

  getBroadcastList = async () => {
    let res = await http.post('/web/broadcast/rank')
    if (res.code == 0) {
      this.setState({
        topHighList:res.res.list ? res.res.list.slice(0,4):[],
        rankingList:res.res.list && res.res.list.length>3 ? res.res.list.slice(3,res.res.list.length):[],
        myRanking:res.res.mine ? res.res.mine : {}
      })
    }
  }

  showRulesModle = (open, close) => {
    let { lang } = this.state
    return (
      <div className="rules-modle" >
        <div className='title-tip'>{lang.rule}</div>
        <div className="prize-modle-body"  onClick={()=>close()}>
        <img className='parchment-bg-top' src='/img/activity/newRamadan/parchment-bg-top.png'></img>
          <div
            className="ru-show-toot"
            dangerouslySetInnerHTML={{ __html: lang ? lang.rulesDeil : '' }}
          ></div>
         <img className='parchment-bg-bm' src='/img/activity/newRamadan/parchment-bg-bm.png'></img>
        </div>
      </div>
    )
  }

  showPrizeModle = (open, close) => {
    let { topReward, voteReward, language, lang } = this.state
    return (
      <div className="prize-modle">
        <div className='title-tip'>{lang.rewards}</div>
        <div className="prize-modle-body-root">
            <div className='prize-modle-body'>
            {topReward.length > 0 && topReward.map((item, index) => (<div className='prize-body-item' key={index}>
              <div className='title-index'>{`${language == 'tr'?'İlk':'Top'}${index + 1}`}</div>
              <div className='body-show-item'>
                {item.length > 0 && item.map((i, d) => (<div className='item-in-prize' key={d + 62}>
                  <div className='img-root'>
                    <img className='img-root-img' style={{ padding: `${i.rewardType == 'title' ? '0.42rem 0' : '0 0'}`, boxSizing: 'border-box' }} src={language == 'tr' ? i.picTr : language == 'ar' ? i.picAr : i.pic}></img>
                    <div className='gift-time-root' >{language == 'ar' ? i.rewardNum + 'يوم' : language == 'tr' ? i.rewardNum + 'Gün' : i.rewardNum + 'day'}</div>
                  </div>
                  <div className='name-text'>{language == 'tr' ? i.rewardNameTr : language == 'ar' ? i.rewardNameAr : i.rewardName}</div>
                </div>))}
              </div>
            </div>))}
            <div className='prize-body-item' >
              <div className='title-index'>{`${language == 'tr'?'İlk4-10':'Top4-10'}`}</div>
              <div className='body-show-item'>
                {voteReward.length > 0 && voteReward.map((item, index) => (<div className='item-in-prize' key={item.rewardId} >
                  <div className='img-root'>
                    <img className='img-root-img' style={{ padding: `${item.rewardType == 'title' ? '0.42rem 0' : '0 0'}`, boxSizing: 'border-box' }} src={language == 'tr' ? item.picTr : language == 'ar' ? item.picAr : item.pic}></img>
                    <div className='gift-time-root' >{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div>
                  </div>
                  <div className='name-text'>{language == 'tr' ? item.rewardNameTr : language == 'ar' ? item.rewardNameAr : item.rewardName}</div>
                </div>))}

              </div>
            </div>
            <div style={{ height: '0.24rem' }}></div>
          </div> 
        </div>
      </div>
    )
  }

  render() {
    let { language, lang, minute, day, hour, second, myRanking, topHighList, rankingList, myInfo, } = this.state
    return (
      <div className={`newRamadan ${language == 'ar' ? 'arlang' : ''}`} >
        <div className="banner" >
          {language == 'en' && <img className="title-root" src="/img/activity/newRamadan/title_text.png"></img>}
          {language == 'ar' && <img className="title-root" src="/img/activity/newRamadan/title_text_ar.png"></img>}
          {language == 'tr' && <img className="title-root" src="/img/activity/newRamadan/title_text_tr.png"></img>}
          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="rules">{lang.rule}</div>
            }}
            slotContentComp={this.showRulesModle}
          />

          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="prize">{lang.rewards}</div>
            }}
            slotContentComp={this.showPrizeModle}
          />
        <div className="time-down">
          <img src="img/activity/newRamadan/icon_hourglass.png"></img> <span className="text">{` ${lang.timeR} ${day} ${lang.days}  ${hour}: ${minute}: ${second}`}</span>
        </div>
        </div>
        <div className='root-for-bg-color'>

        <div className='ranking-top-hig'>
          <div className='title-tip'>{lang.ranking}</div>
          {topHighList[0] && <div className='top-one'>
            <img className='user-img' src={topHighList[0].avatarurl} onClick={()=>jumpToUser(topHighList[0].uid)}></img>
            <img className='user-img-bg' src='img/activity/newRamadan/top_one_head.png' onClick={()=>jumpToUser(topHighList[0].uid)}></img>
            <div className='user-info'>
              <div className='name'>{topHighList[0].nickname}</div>
              <div className='uid'>{topHighList[0].duid}</div>
              <div className='rank-num'>{score(topHighList[0].score)}</div>
            </div>
          </div>}
          {topHighList[1] && <div className='top-two'>
          <img className='user-img' src={topHighList[1].avatarurl} onClick={()=>jumpToUser(topHighList[1].uid)}></img>
          <img className='user-img-bg' src='img/activity/newRamadan/top_two_head.png' onClick={()=>jumpToUser(topHighList[1].uid)}></img>
            <div className='user-info'>
              <div className='name'>{topHighList[1].nickname}</div>
              <div className='uid'>{topHighList[1].duid}</div>
              <div className='rank-num'>{score(topHighList[1].score)}</div>
            </div>
          </div>}
          {topHighList[2] && <div className='top-three'>
          <img className='user-img' src={topHighList[2].avatarurl} onClick={()=>jumpToUser(topHighList[2].uid)}></img>
          <img className='user-img-bg' src='img/activity/newRamadan/top_two_head.png' onClick={()=>jumpToUser(topHighList[2].uid)}></img>
            <div className='user-info'>
              <div className='name'>{topHighList[2].nickname}</div>
              <div className='uid'>{topHighList[2].duid}</div>
              <div className='rank-num'>{score(topHighList[2].score)}</div>
            </div>
          </div>}
        </div>
        <div className='ranking-list'>
          {rankingList.length>0 &&rankingList.map((item,index)=>(<div className='new-ramadan-item' key={index}>
            <div className='left'>
              <div className='left'>{item.rankIdx}</div>
              <div className='right'>
                <img className='user-img' src={item.avatarurl} onClick={()=>jumpToUser(item.uid)}></img>
                <div className='user-info'>
                  <div className='user-name'>{item.nickname}</div>
                  <div className='user-duid'>ID:{item.duid}</div>
                </div>
              </div>
            </div>
            <div className='right'>{score(item.score)}</div>
          </div>)) }
        </div>
        {myInfo.uid && <div className='flex-root' >
          <div className='left'>
            <div className='left'>{myRanking.rankIdx || '--'}</div>
            <div className='right'>
              <img className='user-img' src={myInfo.avatarurl}></img>
              <div className='user-info'>
                <div className='user-name'>{myInfo.nickname}</div>
                <div className='user-duid'>ID:{myInfo.duid}</div>
              </div>
            </div>
          </div>
          <div className='right'>{myRanking.score?score(myRanking.score):'--'}</div>
        </div>}
        </div>
        
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/newRamadan/index.js